import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'
import { IQuestionComponent } from 'app/interfaces/IQuestionComponent'
import { AbstractControl } from '@angular/forms'
import { SurveyViewerService } from '../../../services/survey-viewer.service'
import { Props } from 'app/models/questions/Props'
import { OpenStatementErrorMatcher } from 'app/error-matchers/OpenStatementErrorMatcher'

@Component({
  selector: 'app-props',
  templateUrl: './props.component.html',
  styleUrls: ['./props.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PropsComponent implements IQuestionComponent, OnInit {

  @Input() question: Props
  @Input() isSmallScreen: boolean
  @Input() activeLang: string

  questionFormControl: AbstractControl
  errorMatcher: OpenStatementErrorMatcher

  constructor(public surveyViewerService: SurveyViewerService) { }

  ngOnInit(): void {
    this.errorMatcher = new OpenStatementErrorMatcher(this.question.isOptional)
    this.questionFormControl = this.surveyViewerService.activeSurvey$.value.form.get(this.question.key).get(this.question.rowKeys.pop()).get(this.question.commentsControlName)
    this.question.statementKeys.forEach(sKey => {
      this.surveyViewerService.changeFormUpdateStrategy(this.questionFormControl.get(sKey), 'blur');
    })
  }

}
